<template>
  <div class="scheduleRulesPrompt">
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="600px"
      top="30vh"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="close">
      <div class="content">
        <div v-if="tips" class="tips" v-html="tips"></div>
        <div v-if="list.length > 0" class="table">
          <div class="table_label">{{ label }}</div>
          <div class="table_list">
            <div v-for="(item, index) in list" :key="index" class="list_item">{{ item }}</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer">
        <el-button type="primary" @click="submit">知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'scheduleRulesPrompt',
    data () {
      return {
        visible: false,
        title: '',
        tips: '',
        label: '',
        list: [],
        isLeave: false
      }
    },
    methods: {
      open (options) {
        this.title = options.title || ''
        this.tips = options.tips || ''
        this.label = options.label || ''
        this.list = options.list || []
        this.isLeave = options.isLeave || false
        this.visible = true
      },
      close () {
        this.visible = false
        this.title = ''
        this.tips = ''
        this.label = ''
        this.list = []
        this.isLeave = false
      },
      submit () {
        this.$emit("submit", this.isLeave)
        this.close()
      }
    }
  }
</script>

<style lang="less" scoped>
  .scheduleRulesPrompt /deep/ .el-dialog__header {
    padding: 12px 24px;
    border-bottom: 1px solid #E0E0E0 !important;
  }

  .scheduleRulesPrompt /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .scheduleRulesPrompt /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
    height: 16px;
  }

  .scheduleRulesPrompt /deep/ .el-dialog__body {
    padding: 0;
  }

  .scheduleRulesPrompt /deep/ .el-dialog__footer {
    padding: 12px 16px;
  }

  .content {
    padding: 16px;
  }

  .tips {
    line-height: 20px;
    font-size: 14px;
    color: #1F2329;
  }

  .table {
    box-sizing: border-box;
    margin: 16px 0 0 0;
    width: 100%;
    border: 1px solid #D3D3D5;
  }

  .table_label {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 36px;
    background-color: #F0F1F3;
  }

  .table_list {
    width: 100%;
    max-height: 360px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .list_item {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 12px;
    width: 100%;
    line-height: 20px;
    background-color: #FFFFFF;
    border-top: 1px solid #EBEAEE;
  }
</style>